<template>
  <v-card
    class="py-0 px-0 ma-3 flex-column"
    width="270"
    min-width="270"
    height="380"
    min-height="380"
    :disabled="!authorized"
    flat
    outlined
  >
    <v-container
      class="pa-0 ma-0"
      style="height: 120px; background-size: cover; background-color: dimgrey;"
      :style="{backgroundImage: 'url(' + getBanner + ')'}"
    >
    </v-container>
    <v-col class="py-3 px-4">
      <v-container class="pa-0 ma-0 row" style="position: absolute; top: 80px;">
        <v-img max-width="64" :src="getIcon"></v-img>
      </v-container>
      <v-card-title class="px-0 py-3 mt-3 text-body-1 font-weight-bold">{{info.knownBy.name}}
      </v-card-title>
      <v-container class="pa-0 ma-0 text-body-2" style="height: 135px">
        {{descriptionShort}}
      </v-container>
      <v-spacer></v-spacer>
      <v-container class="row pa-0 ma-0" style="width: 100%">
        <v-row v-if="info.installed" class="px-3">
          <v-btn
            width="90"
            elevation="0"
            color="primary"
            @click="openApp()"
            :disabled="info.status.state > 2"
          >
            Open
            <v-progress-circular
              v-if="info.status.state > 2"
              style="position: absolute;"
              indeterminate
              color="secondary"
            ></v-progress-circular>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn-toggle
            v-model="currentEdition"
            color="primary"
            dense
            group
            mandatory
          >
            <v-tooltip
              v-for="(item, i) in info.availableEditions"
              :key="i"
              top
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :value="item"
                  style="max-width: 40px"
                  v-bind="attrs"
                  v-on="on"
                  icon
                >
                  <v-icon :size="editionProperty(item,'size')">
                    {{editionProperty(item, 'icon')}}</v-icon>
                </v-btn>
              </template>
              <span>{{editionProperty(item, 'title')}}</span>
            </v-tooltip>
          </v-btn-toggle>
        </v-row>
        <v-btn
          v-else-if="info.status.state < 2"
          outlined
          width="90"
          color="primary"
          class="mr-2"
          @click="installApp()"
        >Install</v-btn>
        <v-row
          v-else style="width: 100%"
          class="px-2">
          <div class="text-caption pl-4 pb-1 grey--text">
            Installing {{info.status.percentage}}%
          </div>
          <v-progress-linear
            height="4"
            :value="info.status.percentage"
            buffer-value="0"
            style="width: 100%"
            class="pa-0 ma-0"
            stream
          >
          </v-progress-linear>
        </v-row>
      </v-container>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: 'LabCard',
  props: ['info'],
  methods: {
    editionProperty(index, property) {
      const editionDetails = [{
        title: 'Unknown',
        icon: 'mdi-help-box',
        iconSize: 20,
        index: 0,
      },
      {
        title: 'Middle School',
        icon: 'mdi-home-variant',
        iconSize: 20,
        index: 1,
      },
      {
        title: 'High School',
        icon: 'mdi-bank',
        iconSize: 22,
        index: 2,
      },
      {
        title: 'Higher Ed',
        icon: 'mdi-city',
        iconSize: 28,
        index: 3,
      }];
      return editionDetails[index][property];
    },
    installApp() {
      const message = {
        action: 'install_application',
        payload: {
          application: this.info.knownBy.alternate,
          url: 'https://services.beyondlabz.com/install',
        },
      };
      this.$set(this.info.status, 'state', 2);
      this.$store.dispatch('sendMessage', message);
    },
    openApp() {
      const message = {
        action: 'launch_application',
        payload: {
          application: this.info.knownBy.alternate,
        },
      };
      const currentState = this.info.status.state;
      this.$set(this.info.status, 'state', 3);
      window.setTimeout(() => {
        this.$set(this.info.status, 'state', currentState);
      }, 5000);
      this.$store.dispatch('sendMessage', message);
    },
  },
  computed: {
    descriptionShort() {
      const text = this.info ? this.info.description : '';
      const maxSize = 150;
      return text.length < maxSize ? text : `${text.slice(0, maxSize)}...`;
    },
    getIcon() {
      // TODO: add `iconUrl` property to each app in PortalStateObject.
      return this.$LabDetails.labs[this.info.id].icon;
    },
    getBanner() {
      // TODO: add `bannerUrl` property to each app in PortalStateObject.
      return this.$LabDetails.labs[this.info.id].banner;
    },
    authorized() {
      return this.$store.getters.licenseActive
        && this.$store.getters.authorizations[this.info.knownBy.short];
    },
    currentEdition: {
      get() {
        return this.info.edition;
      },
      set(newValue) {
        const message = {
          action: 'update_application_edition',
          payload: {
            application: this.info.knownBy.short,
            edition: newValue,
          },
        };
        this.$store.dispatch('sendMessage', message);
      },
    },
  },
};
</script>

<style scoped>
</style>
